module.exports = __webpack_public_path__ + "static/media/hamburger.8377e88c.svg";